// PMBOK 8 vocabulary used as UI labels.
// Slugs match the CHECK constraints in migrations/0001_initial_schema.sql.

export const FOCUS_AREAS = [
  { slug: "initiating",              label: "Initiating" },
  { slug: "planning",                label: "Planning" },
  { slug: "executing",               label: "Executing" },
  { slug: "monitoring_controlling",  label: "Monitoring & Controlling" },
  { slug: "closing",                 label: "Closing" },
] as const;

export type FocusAreaSlug = (typeof FOCUS_AREAS)[number]["slug"];

export const PERFORMANCE_DOMAINS = [
  { slug: "governance",   label: "Governance" },
  { slug: "scope",        label: "Scope" },
  { slug: "schedule",     label: "Schedule" },
  { slug: "finance",      label: "Finance" },
  { slug: "stakeholders", label: "Stakeholders" },
  { slug: "resources",    label: "Resources" },
  { slug: "risk",         label: "Risk" },
] as const;

export type PerformanceDomainSlug = (typeof PERFORMANCE_DOMAINS)[number]["slug"];

export const PRINCIPLES = [
  { slug: "holistic_view",       label: "Adopt a Holistic View" },
  { slug: "focus_on_value",      label: "Focus on Value" },
  { slug: "embed_quality",       label: "Embed Quality" },
  { slug: "accountable_leader",  label: "Be an Accountable Leader" },
  { slug: "sustainability",      label: "Integrate Sustainability" },
  { slug: "empowered_culture",   label: "Build an Empowered Culture" },
] as const;

export type PrincipleSlug = (typeof PRINCIPLES)[number]["slug"];

/**
 * In the content planner the PMBOK 8 vocabulary is repurposed as content tags:
 *   Performance Domain → "Pillar"     (content topic)
 *   Focus Area         → "Focus Area" (funnel stage)
 *   Principle          → "Principle"  (optional theme)
 * PILLARS is just an alias so content code reads in its own vocabulary.
 */
export const PILLARS = PERFORMANCE_DOMAINS;
export type PillarSlug = PerformanceDomainSlug;

export function labelFor<T extends { slug: string; label: string }>(
  list: readonly T[],
  slug: string | null | undefined,
): string {
  if (!slug) return "—";
  return list.find((x) => x.slug === slug)?.label ?? slug;
}
